import makeStyles from '@material-ui/core/styles/makeStyles'
import Button from '@material-ui/core/Button'

const useStyles = makeStyles((theme) => ({
    bacCardValueButton: (props) => ({
        width: props.subText ? '86px' : '100%',
        height: '48px',
        borderRadius: '5px',
        cursor: 'pointer',
        backgroundColor: 'white',
        color: '#4F4F4F',
        border: `2px solid #9D9D9D`,
        fontWeight: 600,
        fontSize: '20px',
        padding: props.subText ? '14px 0px 12px' : '15px 0',
        lineHeight: '1em',
        '&.selected, &:hover, &:focus, &.active': {
            backgroundColor: '#FCEDFF',
            border: `2px solid ${theme.palette.primary.main}`,
            color: `${theme.palette.primary.main}`,
        },
        '&.MuiButton-root': {
            minWidth: 'auto',
        },

        ...(props.subText && {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: 'auto',
        }),
        [theme.breakpoints.up('lg')]: {
            height: props.subText ? 'auto' : '2.75rem',
        },
    }),
    contentWrapper: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
    },
    subText: {
        fontSize: '0.65rem',
        fontWeight: 'normal',
        marginTop: '0.3rem',
        textAlign: 'center',
        display: 'block',
        width: '100%',
        lineHeight: '0.8rem',
        letterSpacing: 'normal',
    },
}))

const BacCardValueButton = ({
    defaultCardValue,
    isSelected,
    onValueChange,
    isCurrency = false,
    subText = null,
}) => {
    const classes = useStyles({ subText })

    return (
        <Button
            variant="outlined"
            className={`${classes.bacCardValueButton} ${
                isSelected ? 'selected' : ''
            }`}
            onClick={() => onValueChange(defaultCardValue)}
        >
            {subText ? (
                <div className={classes.contentWrapper}>
                    <div>
                        {isCurrency ? `$${defaultCardValue}` : defaultCardValue}
                    </div>
                    <div className={classes.subText}>{subText}</div>
                </div>
            ) : isCurrency ? (
                `$${defaultCardValue}`
            ) : (
                defaultCardValue
            )}
        </Button>
    )
}

export default BacCardValueButton
